<template>
  <div>
    <footer class="pt-5 pb-5 footer_detail">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="mt-3">
              <img :src="dukaURL+'assets/images/logo-light.png'" alt class="img-fluid footer_logo" />
            </div>

            <div class="mt-4">
              <p class="mb-2">
                <i class="mdi mdi-map-marker"></i> Kigali Marriot Hotel
              </p>
              <p class="mb-2">
                <i class="mdi mdi-cellphone"></i> +250 788 351 158
              </p>
              <p class="mb-2">
                <i class="mdi mdi-email-outline"></i> info@example.com
              </p>
              <ul class="list-inline fot_social mt-4">
                <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-facebook"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-twitter"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-linkedin"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-google-plus"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2">
            <h6 class="mt-3 text-white font-weight-normal">Features</h6>
            <div class="footer_title_border"></div>
            <ul class="list-unstyled footer_menu_list mb-0 mt-4">
              <li>
                <a href="#">Stock</a>
              </li>
              <li>
                <a href="#">Invoice Mangement</a>
              </li>
              <li>
                <a href="#">Expenses tracking</a>
              </li>
            </ul>
          </div>
          <div class="col-lg-2">
            <h6 class="mt-3 text-white font-weight-normal">Help Center</h6>
            <div class="footer_title_border"></div>
            <ul class="list-unstyled footer_menu_list mb-0 mt-4">
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
          <div class="col-lg-2">
            <h6 class="mt-3 text-white font-weight-normal">Locations</h6>
            <div class="footer_title_border"></div>
            <ul class="list-unstyled footer_menu_list mb-0 mt-4">
              <li>
                <a href="#"></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-lg-12">
            <div class="text-center">
              <p
                class="copy-rights mb-0"
              >© {{ new Date().getFullYear() }} Invoice Management in Rwanda</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>
